import { useIsMobile } from "../../../hooks/useIsMobile";
import * as React from "react";

interface VideoProps {
  videoMobileMp4?: string;
  videoMobileWebm?: string;
  posterMobile?: string;
  poster: string;
  videoMp4: string;
  videoWebm: string;
}

/**
 * Video component that renders a responsive video element.
 * The video source and poster image change based on the screen size.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.poster - The poster image for desktop devices.
 * @param {string} props.videoMp4 - The MP4 video source for desktop devices.
 * @param {string} props.videoWebm - The WebM video source for desktop devices.
 * @returns {JSX.Element} The rendered video component.
 */
export const Video: React.FC<VideoProps> = ({ poster, videoMp4, videoWebm }): JSX.Element => {
  const [videoWidth, setVideoWidth] = React.useState<number>(0);
  const aspectRatio = 16 / 9;

  function setVideoSize(): void {
    setVideoWidth(window.innerWidth);
  }

  React.useEffect(() => {
    setVideoSize();
    const handleResize = () => setVideoSize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        minWidth: `${videoWidth}px`,
      }}
      className={`safari-ios-overflow-fix !tw-overflow-hidden`}
    >
      <div
        style={{
          minWidth: `${videoWidth}px`,
          height: `${videoWidth / aspectRatio}px`,
        }}
        className={`tw-bg-black`}
      >
        <video
          autoPlay={true}
          loop={true}
          muted={true}
          playsInline={true}
          preload="auto"
          poster={poster}
          width={videoWidth}
          height={videoWidth / aspectRatio}
        >
          <source src={videoWebm} type="video/webm" />
          <source src={videoMp4} type="video/mp4" />
          <track label="English" kind="captions" srcLang="en" src="" />
        </video>
      </div>
    </div>
  );
};
